import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20ZM10 15.9167C9.30964 15.9167 8.75 15.357 8.75 14.6667V9.66667C8.75 8.97631 9.30964 8.41667 10 8.41667C10.6904 8.41667 11.25 8.97631 11.25 9.66667V14.6667C11.25 15.357 10.6904 15.9167 10 15.9167ZM11.25 5.5C11.25 4.80964 10.6904 4.25 10 4.25C9.30964 4.25 8.75 4.80964 8.75 5.5C8.75 6.19036 9.30964 6.75 10 6.75C10.6904 6.75 11.25 6.19036 11.25 5.5Z"
      transform="translate(2 2)"
      fill={fill}
    />
  </g>
);

export default Icon;
